var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"none","stroke":"currentColor","aria-hidden":"true","viewBox":"0 0 17.243 17.243","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"stroke-linecap":"round","stroke-width":"3"}},[_c('path',{attrs:{"d":"M2.121 15.121l13-13"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2.121 2.121l13 13"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }